export default "__VITE_ASSET__2VxtfYBo__"